import React from "react";
import { Box } from "@mui/material";

const ElbowNWristPage = () => {
  return (
    <Box
      sx={{
        padding: 10,
      }}
    >
      {"WIP: Elbow & Wrist"}
    </Box>
  );
};

export default ElbowNWristPage;
